export default __webpack_public_path__ + "static/media/Graze the Grass.bfbbf944.png";